import auth from './auth';
import brands from './brands';
import products from './products';
import categories from './categories';
import statistic from './statistic';
import priceSources from './priceSources';
import characteristics from './characteristics';
import feeds from './feeds';

const api = {
  auth,
  brands,
  products,
  categories,
  statistic,
  priceSources,
  characteristics,
  feeds,
};

export default api;
